import React, { useState, useEffect, useRef } from 'react';

const DecryptedText = ({
  text,
  speed = 50,
  maxIterations = 10,
  characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+-=[]{}|;:,.<>?',
  className = '',
  parentClassName = '',
  encryptedClassName = '',
  animateOn = 'hover', // 'hover' or 'view'
  revealDirection = 'left', // 'left', 'right', 'center'
  delay = 0 // delay in milliseconds
}) => {
  const [displayText, setDisplayText] = useState(text);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isRevealed, setIsRevealed] = useState(false);
  const intervalRef = useRef(null);
  const elementRef = useRef(null);

  const getRandomChar = () => {
    return characters[Math.floor(Math.random() * characters.length)];
  };

  const animateText = () => {
    if (isAnimating) return;
    
    setIsAnimating(true);
    setIsRevealed(false);
    
    let iteration = 0;
    
    const animate = () => {
      const chars = text.split('');
      
      setDisplayText(
        chars.map((char, index) => {
          if (char === ' ') return ' ';
          
          let revealIndex;
          if (revealDirection === 'center') {
            const center = Math.floor(chars.length / 2);
            revealIndex = Math.abs(index - center);
          } else if (revealDirection === 'right') {
            revealIndex = chars.length - 1 - index;
          } else {
            revealIndex = index;
          }
          
          if (iteration > revealIndex) {
            return char;
          }
          
          return getRandomChar();
        }).join('')
      );
      
      iteration++;
      
      if (iteration <= Math.max(text.length, maxIterations)) {
        setTimeout(animate, speed);
      } else {
        setDisplayText(text);
        setIsAnimating(false);
        setIsRevealed(true);
      }
    };
    
    animate();
  };

  // Handle view animation
  useEffect(() => {
    if (animateOn === 'view') {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !isRevealed) {
              setTimeout(() => {
                animateText();
              }, delay);
            }
          });
        },
        { threshold: 0.1 }
      );

      if (elementRef.current) {
        observer.observe(elementRef.current);
      }

      return () => {
        if (elementRef.current) {
          observer.unobserve(elementRef.current);
        }
      };
    }
  }, [animateOn, isRevealed, delay]);

  const handleMouseEnter = () => {
    if (animateOn === 'hover') {
      animateText();
    }
  };

  return (
    <span
      ref={elementRef}
      className={`${parentClassName} ${isRevealed ? className : encryptedClassName}`}
      onMouseEnter={handleMouseEnter}
      style={{ 
        fontFamily: 'monospace',
        cursor: animateOn === 'hover' ? 'pointer' : 'default'
      }}
    >
      {displayText}
    </span>
  );
};

export default DecryptedText;